import { fomatTime, fomatTimeStr } from "@/components/common/utils/time";

export function fomatSearchTrendsData(keyword,trends) {
	let data_arr = [];
	trends = trends || []
	trends.forEach( i => {
		data_arr.push([i.month,i.searches])
	})
	
	return getOption(keyword,data_arr,"搜索量")
}

export function fomatSearchTrendsData2(keyword,trends) {
	let data_arr = [];
	trends = trends || []
	trends.forEach( i => {
		data_arr.push([i.date,i.search_frequency_rank])
	})
	return getOption(keyword,data_arr,"搜索排名")
}

function getOption(keyword,data_arr,title) {
	return {
		chart: {
			type: 'area',
			margin: [0, 0, 0, 0],
			skipClone: true
		},
		title: {
			text: ' '
		},
		xAxis: {
			crosshair: true,
			visible :false,
		},
		yAxis: {
			crosshair: true,
			visible: false,
		},
		credits: {
			enabled: false
		},
		legend: {
			enabled: false
		},
		tooltip: {
			outside: true,
			useHTML: true,
			headerFormat: null,
			pointFormatter: function() {
				return '<div style="font-size: 16px;">'+ fomatTime(this.options.name) +'</div>' +
					'<div style="font-size: 15px;margin-top: 5px">' + title + ': ' +
					'<span class="emphasis-hint">' + this.options.y + '</span>' +
					'</div>'
			}
		},
		plotOptions: {
			series: {
				animation: false,
				lineWidth: 1,
				shadow: false,
				states: {
					hover: {
						lineWidth: 1
					}
				},
				marker: {
					radius: 1,
					states: {
						hover: {
							radius: 2
						}
					}
				},
				fillOpacity: 0.25
			},
			area: {
				marker: {
					enabled: false,
					symbol: 'circle',
					radius: 2,
					states: {
						hover: {
							enabled: true
						}
					}
				}
			}
		},
		series: [{
			name: keyword,
			data : data_arr
		}],
	}
}